import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { actionIcons } from '../../../../../configs/Icons';
import { useAuth } from '../../../../Contexts/AuthProvider';
import { UserCardV2 } from '../../../../features/User/UserCard';
import { GetDate } from '../../../../utils/Show';
import cn from '../../../../utils/cn';

function LogoutButton({ onclick, disabled }) {
    return (
        <button
            type="button"
            onClick={onclick}
            disabled={disabled}
            className={disabled ? 'grayscale-[100%] pointer-events-none' : ''}
            aria-label="Loading..."
        >
            <img src={actionIcons.accessWF} alt="" className="block" />
        </button>
    );
}

function TableInfoCard({ name, value, isCapitalize, className }) {
    return (
        <div
            className={cn(
                'text-sm text-primary-700 font-medium flex flex-row gap-3 justify-start items-center h-auto',
                className
            )}
        >
            <p className="inline-flex justify-between items-center min-w-[112px] w-28">
                <span>{name}</span>
                <span>:</span>
            </p>
            <span
                className={cn(`value-text line-clamp-1 text-primary font-normal text-sm`, {
                    capitalize: isCapitalize
                })}
            >
                {value}
            </span>
        </div>
    );
}

function TableRow({ item, handleLogoutClick }) {
    const [isActive, setIsActive] = useState(false);

    const { authInfo } = useAuth();

    return (
        <div
            tabIndex={-1}
            role="button"
            onClick={() => setIsActive(!isActive)}
            className={cn(
                `table-visible-data overflow-hidden w-full flex flex-col justify-between text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight`,
                {
                    'max-h-80': isActive,
                    'max-h-10': !isActive,
                    'placeholder-mode': item.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-1 justify-between text-primary text-sm font-medium leading-normal">
                <div className="min-w-[112px] w-28">
                    <span>{item?.id}</span>
                </div>
                <div className="w-full">
                    <span className="line-clamp-1">{item?.userName}</span>
                </div>
                <div className="w-full hidden sm:block">
                    <span className="line-clamp-1">{item?.primaryPhone}</span>
                </div>
            </div>

            <div className="table-data-more mt-3.5 flex flex-col justify-start items-item gap-2">
                <TableInfoCard
                    name="Organization"
                    value={
                        item.organization ? (
                            <Link
                                to={`/customers/${item?.id}/info`}
                                className="text-primary-700 underline font-medium"
                            >
                                {item.organization}
                            </Link>
                        ) : (
                            '--'
                        )
                    }
                />
                <TableInfoCard
                    name="Name & Email"
                    value={
                        <UserCardV2
                            icon={item?.photoUrl}
                            title={`${item?.firstName || ''} ${item?.lastName || ''}`}
                            subTitle={item?.primaryEmail}
                        />
                    }
                    className="my-2"
                />

                <TableInfoCard
                    name="Date Created"
                    value={GetDate(item?.timeCreated)}
                    isCapitalize
                />

                <TableInfoCard
                    name="Phone Number"
                    value={item?.primaryPhone}
                    isCapitalize
                    className={`sm:hidden'}`}
                />

                <div className="flex flex-row gap-px justify-end items-center">
                    <LogoutButton
                        onclick={(ev) => handleLogoutClick(ev, item?.id)}
                        disabled={authInfo?.data?.id === item?.id}
                    />
                </div>
            </div>
        </div>
    );
}

function PageTableMobile({ data, handleLogoutClick }) {
    return (
        <div className="auth_manage_page_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50">
                {data && data?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">No Data Found</div>
                ) : (
                    data?.map((item) => (
                        <TableRow key={item.id} item={item} handleLogoutClick={handleLogoutClick} />
                    ))
                )}
            </div>
        </div>
    );
}

export default PageTableMobile;
